import { useMsal } from '@azure/msal-react';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import React from 'react';

const API_SCOPE = 'api://' + process.env.REACT_APP_AAD_CLIENT_ID + '/user_impersonation';

export const getCurrentUserId = (account: { username?: string; localAccountId: string } | null): string => {
  if (account) {
    return account.username || account.localAccountId;
  }
  return 'anonymous';
};

export const useAuthToken = () => {
  const { instance, accounts } = useMsal();
  const [token, setToken] = React.useState<string | null>(null);
  const account = accounts[0] || null;
  
  const getToken = React.useCallback(async () => {
    if (accounts.length > 0) {
      try {
        const tokenResponse = await instance.acquireTokenSilent({
          scopes: [API_SCOPE],
          account: accounts[0]
        });
        setToken(tokenResponse.accessToken);
        return tokenResponse.accessToken;
      } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
          try {
            const response = await instance.acquireTokenPopup({
              scopes: [API_SCOPE]
            });
            setToken(response.accessToken);
            return response.accessToken;
          } catch (e) {
            console.error('Error acquiring token popup:', e);
            setToken(null);
            return undefined;
          }
        }
        console.error('Error acquiring token:', error);
        setToken(null);
        return undefined;
      }
    }
    setToken(null);
    return undefined;
  }, [instance, accounts]);

  // Refresh token when accounts change
  React.useEffect(() => {
    getToken();
  }, [getToken, accounts]);

  return { 
    getToken, 
    token, 
    isAuthenticated: accounts.length > 0,
    account
  };
}; 